import * as React from 'react';

const CheckInChunkySvg = (props: React.SVGProps<SVGSVGElement>) => (
    <svg
        id="check-in-chunky_svg__eds-icon--check-in-chunky_svg"
        x={0}
        y={0}
        viewBox="0 0 24 24"
        xmlSpace="preserve"
        {...props}
    >
        <path
            id="check-in-chunky_svg__eds-icon--check-in-chunky_base"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M16 6h2v12h-2v2h4V4h-4v2z"
        />
        <path
            id="check-in-chunky_svg__eds-icon--check-in-chunky_arrow"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M16 12l-5-5-1.4 1.4 2.6 2.6H4v2h8.2l-2.6 2.6L11 17z"
        />
    </svg>
);

CheckInChunkySvg.displayName = 'CheckInChunkySvg';
export default CheckInChunkySvg;
